import axios from 'axios'
import { createResource } from '../utils/resource'

const baseStore = createResource('academy/enrollments', {})

const academyEnrollment = {
  ...baseStore,
  actions: {
    ...baseStore.actions,
    async getMyEnrollments() {
      try {
        const result = await axios.get('/api/academy/enrollments/my')
        return { data: result.data as any[], error: null }
      } catch (e) {
        return { data: null, error: e }
      }
    },

    async getEnrollmentDetails({}, { id }: { id: string }) {
      try {
        const result = await axios.get(`/api/academy/enrollments/${id}/details`)
        return { data: result.data as any[], error: null }
      } catch (e) {
        return { data: null, error: e }
      }
    },

    async completeCourse({}, { id }: { id: string }) {
      try {
        const result = await axios.post(`/api/academy/enrollments/${id}/complete`)
        return { data: result.data, error: null }
      } catch (e) {
        return { data: null, error: e }
      }
    },
  },
}

export default academyEnrollment
